// src/router/guards/exhibitionSettingsGuard.js

import { Platform } from 'quasar'
import { usePermissionsStore } from '@/stores/index.js'

// La Configuracion de catalogos de exhibiciones es solo-movil y solo para
// usuarios con el permiso 'assign-exhibitions'. En dev (web) se permite para pruebas.
export function exhibitionSettingsGuard () {
  if (!Platform.is.capacitor && !import.meta.env.DEV) {
    return { name: 'navigation.home' }
  }

  const permissionsStore = usePermissionsStore()
  if (!permissionsStore.hasAccessTo('assign-exhibitions')) {
    return { name: 'navigation.exhibitions.index' }
  }

  return true
}
